// src/modules/agendamentoindividual/index.jsx

import React, { useState, useEffect, useCallback } from "react";
import env from "../../config/env.js";
// import { getHeaders, criarLogAuth } from "../../utils/apiUtils"; // Removido - não utilizado
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, TableSortLabel,
  Tooltip, Select, MenuItem, InputLabel, FormControl,
  Snackbar, Alert, TablePagination, CircularProgress, FormHelperText,
  Chip, Autocomplete
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import {
  Add as AddIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  Visibility as VisibilityIcon
} from "@mui/icons-material";
import api from "../../services/api";
import AcessoRestrito from '../../components/AcessoRestrito';
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { 
  formatarCPFCNPJLGPD
  // formatarTelefoneLGPD, // Removido - não utilizado
  // formatarEmailLGPD // Removido - não utilizado
} from "../../utils/lgpd";

export default function AgendamentoIndividual() {
  const [agendamentos, setAgendamentos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [locais, setLocais] = useState([]);
  const [servicos, setServicos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [formData, setFormData] = useState({
    clienteId: '',
    colaboradorId: '',
    localId: '',
    servicoId: '',
    dataHoraInicio: '',
    dataHoraFim: '',
    horaInicio: '',
    horaFim: '',
    st_codHashEmpresa: '',
    local_execucao: {
      tipo: '',
      local: ''
    },
    observacoes: '',
    status: 'Agendado'
  });
  const [agendamentoSelecionado, setAgendamentoSelecionado] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [orderBy, setOrderBy] = useState("dataHoraInicio");
  const [order, setOrder] = useState("asc");
  const [filtros, setFiltros] = useState({
    cliente: '',
    colaborador: '',
    local: ''
  });
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [disponibilidadeColaborador, setDisponibilidadeColaborador] = useState([]);
  const [diasSelecionados, setDiasSelecionados] = useState([]);
  const [dataSelecionada, setDataSelecionada] = useState(null);
  const [horariosDisponiveis, setHorariosDisponiveis] = useState([]);
  const [colaboradoresServico, setColaboradoresServico] = useState([]);
  const [clientesOrdenados, setClientesOrdenados] = useState([]);

  // Funções de conversão entre formato JavaScript (0-6) e formato do sistema (1-7)
  // JavaScript: 0=Domingo, 1=Segunda, 2=Terça, 3=Quarta, 4=Quinta, 5=Sexta, 6=Sábado
  // Sistema: 1=Domingo, 2=Segunda, 3=Terça, 4=Quarta, 5=Quinta, 6=Sexta, 7=Sábado
  const converterJSparaSistema = (diaJS) => {
    // Converte de JS (0-6) para Sistema (1-7): Domingo=0 -> 1, Sábado=6 -> 7
    return diaJS === 0 ? 1 : diaJS + 1;
  };
  
  const converterSistemaparaJS = (diaSistema) => {
    // Converte de Sistema (1-7) para JS (0-6): Domingo=1 -> 0, Sábado=7 -> 6
    return diaSistema === 1 ? 0 : diaSistema - 1;
  };

  const diasSemana = {
    1: 'Domingo',
    2: 'Segunda-feira',
    3: 'Terça-feira',
    4: 'Quarta-feira',
    5: 'Quinta-feira',
    6: 'Sexta-feira',
    7: 'Sábado'
  };

  // Função para criar logs de autenticação
  const criarLogAuth = async (acao, descricao, metodo_http, endpoint, status_http = 200) => {
    try {
      const token = localStorage.getItem("token");
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      
      // Decodifica o token para obter informações do usuário
      let tokenPayload = {};
      try {
        tokenPayload = JSON.parse(atob(token.split('.')[1]));
      } catch (decodeError) {
        tokenPayload = {
          perfil: "usuario",
          email: "usuario@sistema.com"
        };
      }
      
      const logData = {
        tipo_usuario: tokenPayload.perfil || "usuario",
        email: tokenPayload.email || "usuario@sistema.com",
        ip: env.CLIENT_IP, // IP fixo para exemplo
        acao: acao,
        descricao: descricao,
        modulo: "agendamentoindividual",
        metodo_http: metodo_http,
        endpoint: endpoint,
        status_http: status_http,
        userAgent: navigator.userAgent,
        sistema: "authsystem",
        st_codHashEmpresa: codHashEmpresa,
        transactionHash: codHashEmpresa
      };

      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

      await api.post('/logs', logData, { headers });
    } catch (err) {
      console.error('❌ Erro ao criar log de autenticação:', err);
      // Não interrompe o fluxo principal se o log falhar
    }
  };

  // Buscar dados necessários
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
        const headers = {
          'Authorization': `Bearer ${token}`,
          'x-second-key': env.SECOND_SECRET_KEY
        };

        // Buscar clientes
        const resClientes = await api.get('/clientes', { headers });
        if (resClientes.data && Array.isArray(resClientes.data)) {
          setClientes(resClientes.data);
        } else {
          setClientes([]);
        }

        // Buscar colaboradores (com filtro por empresa, como no módulo de colaboradores)
        const resColaboradores = await api.get(`/colaboradores?st_codHashEmpresa=${codHashEmpresa}`, { headers });
        if (resColaboradores.data && Array.isArray(resColaboradores.data)) {
          // Filtrar colaboradores por empresa (mesma lógica do módulo de colaboradores)
          let colaboradoresFiltrados = resColaboradores.data;
          const usuario = JSON.parse(localStorage.getItem("usuario") || "{}");
          if (usuario.perfil !== "superusuario") {
            colaboradoresFiltrados = resColaboradores.data.filter(colaborador =>
              colaborador.st_codHashEmpresa === codHashEmpresa
            );
          }
          setColaboradores(colaboradoresFiltrados);
        } else {
          setColaboradores([]);
        }

        // Buscar locais
        const resLocais = await api.get(`/local?st_codHashEmpresa=${codHashEmpresa}`, { headers });
        setLocais(resLocais.data);

        // Buscar serviços
        const resServicos = await api.get('/servicos', {
          headers,
          params: { todos: true }
        });
        if (resServicos.data && resServicos.data.dados) {
          setServicos(resServicos.data.dados);
        } else {
          setServicos([]);
        }

        // Buscar agendamentos
        const resAgendamentos = await api.get('/agendamentos', { headers });
        if (resAgendamentos.data && Array.isArray(resAgendamentos.data)) {
          setAgendamentos(resAgendamentos.data);
        } else {
          setAgendamentos([]);
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao carregar dados');
      }
    };
    fetchData();
  }, []);

  // Ordenar clientes quando forem carregados
  useEffect(() => {
    if (Array.isArray(clientes) && clientes.length > 0) {
      const ordenados = [...clientes].sort((a, b) => {
        const nomeA = (a.nome_completo || a.nome || '').toLowerCase();
        const nomeB = (b.nome_completo || b.nome || '').toLowerCase();
        return nomeA.localeCompare(nomeB);
      });
      setClientesOrdenados(ordenados);
    } else {
      setClientesOrdenados([]);
    }
  }, [clientes]);

  const calcularHoraFim = (horaInicio, servicoId) => {
    if (!horaInicio || !servicoId) return '';
    
    const servico = servicos.find(s => s.id === servicoId);
    if (!servico || !servico.duracao_minutos) return '';

    const [horas, minutos] = horaInicio.split(':').map(Number);
    const data = new Date();
    data.setHours(horas);
    data.setMinutes(minutos);
    
    // Adiciona a duração do serviço em minutos
    data.setMinutes(data.getMinutes() + servico.duracao_minutos);
    
    return `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;
  };

  const handleInputChange = (event) => {
    if (viewMode) return; // Não permite alterações no modo de visualização
    
    const { name, value } = event.target;
    
    // Em modo de edição, só permite alterar o campo "observacoes"
    const isEditMode = agendamentoSelecionado != null && !viewMode;
    if (isEditMode && name !== 'observacoes') {
      return; // Não permite alterar outros campos em modo de edição
    }
    
    // Se mudou o serviço, limpa os campos dependentes
    if (name === 'servicoId') {
      // Não limpa em modo de edição
      if (!isEditMode) {
        // Limpa colaborador selecionado
        setFormData(prev => ({
          ...prev,
          [name]: value,
          colaboradorId: '',
          localId: '',
          dataHoraInicio: '',
          dataHoraFim: '',
          horaInicio: '',
          horaFim: ''
        }));
        
        // Limpa campos relacionados
        setDisponibilidadeColaborador([]);
        setDiasSelecionados([]);
        setDataSelecionada(null);
        setHorariosDisponiveis([]);
        
        // Atualiza local_execucao com os dados do novo serviço
        const servicoSelecionado = servicos.find(s => s.id === value);
        if (servicoSelecionado?.local_execucao) {
          setFormData(prev => ({
            ...prev,
            local_execucao: {
              ...servicoSelecionado.local_execucao
            }
          }));
        } else {
          setFormData(prev => ({
            ...prev,
            local_execucao: {
              tipo: '',
              local: ''
            }
          }));
        }
      } else {
        // Em modo de edição, apenas atualiza o local_execucao
        const servicoSelecionado = servicos.find(s => s.id === value);
        setFormData(prev => {
          const newData = { ...prev, [name]: value };
          if (servicoSelecionado?.local_execucao) {
            newData.local_execucao = {
              ...servicoSelecionado.local_execucao
            };
          }
          return newData;
        });
      }
    } else {
      // Outros campos que não são servicoId
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    
    setFormErrors(prev => ({ ...prev, [name]: false }));
  };

  // const handleNestedInputChange = (campo, subcampo, valor) => { // Removido - não utilizado
  //   setFormData(prev => ({
  //     ...prev,
  //     [campo]: {
  //       ...prev[campo],
  //       [subcampo]: valor
  //     }
  //   }));
  // };

  const handleOpenForm = async (agendamento = null, isViewMode = false) => {
    if (agendamento) {
      // Buscar dados relacionados para garantir que temos tudo
      // Normaliza IDs para comparação (pode ser Number ou String)
      const clienteIdNorm = agendamento.clienteId ? String(agendamento.clienteId) : null;
      const servicoIdNorm = agendamento.servicoId ? String(agendamento.servicoId) : null;
      const localIdNorm = agendamento.localId ? Number(agendamento.localId) : null;
      const colaboradorIdNorm = agendamento.colaboradorId ? Number(agendamento.colaboradorId) : null;
      
      const cliente = clienteIdNorm ? clientes.find(c => String(c.id) === clienteIdNorm) : null;
      const servico = servicoIdNorm ? servicos.find(s => String(s.id) === servicoIdNorm) : null;
      const local = localIdNorm ? locais.find(l => Number(l.id) === localIdNorm || String(l.id) === String(localIdNorm)) : null;
      
      // Extrair informações do local de execução do serviço ou do agendamento
      let localExecucao = {
        tipo: '',
        local: ''
      };
      
      if (servico?.local_execucao) {
        localExecucao = {
          tipo: servico.local_execucao.tipo || '',
          local: servico.local_execucao.local || ''
        };
      } else if (agendamento.local_execucao) {
        localExecucao = {
          tipo: agendamento.local_execucao.tipo || '',
          local: agendamento.local_execucao.local || ''
        };
      } else if (local) {
        localExecucao = {
          tipo: 'presencial',
          local: local.nome || local.endereco || ''
        };
      }
      
      // Normaliza valores do MongoDB (pode vir como Number com decimal 20.0)
      const colaboradorIdRaw = agendamento.colaboradorId;
      const colaboradorId = colaboradorIdRaw != null && colaboradorIdRaw !== '' 
        ? Number(colaboradorIdRaw) 
        : '';
      const clienteId = agendamento.clienteId != null && agendamento.clienteId !== ''
        ? Number(agendamento.clienteId)
        : '';
      const localId = agendamento.localId != null && agendamento.localId !== ''
        ? Number(agendamento.localId)
        : '';
      
      setFormData({
        clienteId: clienteId,
        colaboradorId: colaboradorId,
        servicoId: agendamento.servicoId || '',
        localId: localId,
        dataHoraInicio: agendamento.dataHoraInicio || '',
        dataHoraFim: agendamento.dataHoraFim || '',
        st_codHashEmpresa: agendamento.st_codHashEmpresa || localStorage.getItem("st_codHashEmpresa"),
        local_execucao: localExecucao,
        observacoes: agendamento.observacoes || '',
        status: agendamento.status || 'Agendado'
      });
      
      setAgendamentoSelecionado(agendamento);
      setClienteSelecionado(cliente);
      
      // Buscar disponibilidade do colaborador e colaboradores do serviço
      if (agendamento.colaboradorId) {
        buscarDisponibilidadeColaborador(agendamento.colaboradorId);
      }
      
      if (agendamento.servicoId) {
        buscarColaboradoresServico(agendamento.servicoId);
        
        // Se houver dataHoraInicio, extrair data e hora para popular campos
        if (agendamento.dataHoraInicio) {
          try {
            const dataHora = new Date(agendamento.dataHoraInicio);
            if (!isNaN(dataHora.getTime())) {
              setDataSelecionada(dataHora);
              
              // Extrair dia da semana e definir diasSelecionados
              const diaSemanaJS = dataHora.getDay(); // JS retorna 0-6
              const diaSemana = converterJSparaSistema(diaSemanaJS); // Converte para formato do sistema (1-7)
              setDiasSelecionados([diaSemana]);
              
              // Calcular horários disponíveis usando a API oficial da Engine
              if (agendamento.servicoId && agendamento.colaboradorId) {
                buscarHorariosDisponiveisAPI(dataHora, agendamento.colaboradorId, agendamento.servicoId);
              }
            }
          } catch (dateError) {
            // Ignora erros de data
          }
        }
      }
    } else {
      setFormData({
        clienteId: '',
        colaboradorId: '',
        localId: '',
        servicoId: '',
        dataHoraInicio: '',
        dataHoraFim: '',
        st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa"),
        local_execucao: {
          tipo: '',
          local: ''
        },
        observacoes: '',
        status: 'Agendado'
      });
      setAgendamentoSelecionado(null);
      setClienteSelecionado(null);
      setDisponibilidadeColaborador([]);
      setDiasSelecionados([]);
      setDataSelecionada(null);
      setHorariosDisponiveis([]);
    }
    setOpenForm(true);
    setViewMode(isViewMode);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setViewMode(false);
    setFormData({
      clienteId: '',
      colaboradorId: '',
      localId: '',
      servicoId: '',
      dataHoraInicio: '',
      dataHoraFim: '',
      st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa"),
      local_execucao: {
        tipo: '',
        local: ''
      },
      observacoes: '',
      status: 'Agendado'
    });
    setAgendamentoSelecionado(null);
    setClienteSelecionado(null);
    setDisponibilidadeColaborador([]);
    setDiasSelecionados([]);
    setDataSelecionada(null);
    setHorariosDisponiveis([]);
    setFormErrors({});
  };

  const handleOpenDelete = (agendamento) => {
    if (!agendamento) {
      setError('Agendamento inválido');
      return;
    }
    
    if (!agendamento._id) {
      setError('ID do agendamento inválido');
      return;
    }
    
    setAgendamentoSelecionado(agendamento);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
    setAgendamentoSelecionado(null);
  };

  // Validação
  const validar = () => {
    const errors = {};
    if (!formData.clienteId) errors.clienteId = true;
    if (!formData.colaboradorId) errors.colaboradorId = true;
    if (!formData.servicoId) errors.servicoId = true;
    if (!formData.dataHoraInicio) errors.dataHoraInicio = true;
    if (!dataSelecionada) errors.dataSelecionada = true;

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Salvar (POST/PUT)
  const handleSalvar = async () => {
    if (!validar()) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

      // Validações adicionais
      if (!formData.st_codHashEmpresa) {
        setError('Hash da empresa não encontrado');
        setLoading(false);
        return;
      }

      // Busca o serviço selecionado para obter o localId
      const servicoSelecionado = servicos.find(s => s.id === formData.servicoId);
      
      // Verifica se o serviço tem local definido
      if (!servicoSelecionado?.local_execucao?.id) {
        setError('O serviço selecionado não possui um local válido');
        setLoading(false);
        return;
      }

      // Verifica se o serviço tem duração definida
      if (!servicoSelecionado?.duracao_minutos) {
        setError('O serviço selecionado não possui duração definida');
        setLoading(false);
        return;
      }
      
      // Usa exatamente o horário selecionado na tela
      const dataHoraInicio = formData.dataHoraInicio;
      
      // Valida se a data está no formato correto
      if (!dataHoraInicio || !dataHoraInicio.includes('T')) {
        setError('Data/hora inválida');
        setLoading(false);
        return;
      }
      
      // Formata os dados para o formato esperado pela API (sem dataHoraFim - backend calcula)
      // Converter servicoId para número se for string
      const servicoIdFinal = typeof formData.servicoId === 'string' 
        ? (isNaN(Number(formData.servicoId)) ? formData.servicoId : Number(formData.servicoId))
        : formData.servicoId;
      
      // Normalizar tipo de local_execucao (deve ser 'presencial', 'online' ou 'hibrido' em minúsculas)
      const tipoLocalExecucao = (formData.local_execucao.tipo || servicoSelecionado.local_execucao?.tipo || 'presencial')
        .toLowerCase()
        .trim();
      
      // Validar e corrigir tipo se necessário
      const tiposPermitidos = ['presencial', 'online', 'hibrido'];
      const tipoFinal = tiposPermitidos.includes(tipoLocalExecucao) 
        ? tipoLocalExecucao 
        : 'presencial';
      
      const dadosAgendamento = {
        clienteId: parseInt(formData.clienteId),
        colaboradorId: parseInt(formData.colaboradorId),
        servicoId: servicoIdFinal,
        localId: parseInt(servicoSelecionado.local_execucao.id),
        dataHoraInicio: dataHoraInicio,
        st_codHashEmpresa: formData.st_codHashEmpresa,
        // Campos adicionais
        local_execucao: {
          tipo: tipoFinal,
          local: (formData.local_execucao.local || servicoSelecionado.local_execucao?.local || '').trim()
        },
        // Garantir que observacoes seja sempre enviado, mesmo que vazio
        observacoes: (formData.observacoes !== undefined && formData.observacoes !== null && formData.observacoes.trim())
          ? formData.observacoes.trim()
          : '',
        status: formData.status || 'Agendado'
      };
      
      // Log para debug
      console.log('📤 [FRONTEND] Dados formatados para envio:', JSON.stringify(dadosAgendamento, null, 2));

      if (agendamentoSelecionado) {
        // Atualização: Excluir o agendamento existente e criar um novo com as alterações
        const agendamentoId = agendamentoSelecionado._id || agendamentoSelecionado.id;
        
        if (!agendamentoId) {
          setError('ID do agendamento não encontrado');
          setLoading(false);
          return;
        }
        
        // 1. Deletar o agendamento existente
        try {
          await api.delete(`/agendamentos/${agendamentoId}`, { headers });
        } catch (deleteError) {
          // Se o DELETE falhar, tenta continuar mesmo assim (pode ser que o agendamento já não exista)
          console.warn('⚠️ [WARN] Erro ao deletar agendamento (continuando com criação):', deleteError);
        }
        
        // 2. Criar um novo agendamento com os dados atualizados
        await api.post('/agendamentos', dadosAgendamento, { headers });
        
        // Busca informações para o log
        const cliente = clientes.find(c => c.id === parseInt(formData.clienteId));
        const colaborador = colaboradores.find(c => c.id === parseInt(formData.colaboradorId));
        const servico = servicos.find(s => s.id === formData.servicoId);
        
        const descricao = `Atualizou agendamento (excluiu e recriou) para cliente ${cliente?.nome_completo || 'N/A'}, colaborador ${colaborador?.nome_completo || 'N/A'}, serviço ${servico?.nome || 'N/A'} em ${format(new Date(dataHoraInicio), 'dd/MM/yyyy HH:mm')}`;
        
        await criarLogAuth(
          "ATUALIZACAO",
          descricao,
          "DELETE+POST",
          `/agendamentos/${agendamentoId} -> /agendamentos`
        );
        
        setSuccess('Agendamento atualizado com sucesso!');
      } else {
        // Criação (POST)
        await api.post('/agendamentos', dadosAgendamento, { headers });
        
        // Busca informações para o log
        const cliente = clientes.find(c => c.id === parseInt(formData.clienteId));
        const colaborador = colaboradores.find(c => c.id === parseInt(formData.colaboradorId));
        const servico = servicos.find(s => s.id === formData.servicoId);
        
        const descricao = `Criou agendamento para cliente ${cliente?.nome_completo || 'N/A'}, colaborador ${colaborador?.nome_completo || 'N/A'}, serviço ${servico?.nome || 'N/A'} em ${format(new Date(dataHoraInicio), 'dd/MM/yyyy HH:mm')}`;
        
        await criarLogAuth(
          "CRIACAO",
          descricao,
          "POST",
          "/agendamentos"
        );
        
        setSuccess('Agendamento cadastrado com sucesso!');
      }
      handleCloseForm();
      carregarAgendamentos();
    } catch (err) {
      console.error('❌ [FRONTEND] Erro ao salvar agendamento:', err);
      console.error('❌ [FRONTEND] Detalhes do erro:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        statusText: err.response?.statusText
      });
      
      const mensagemErro = err.response?.data?.message || 
                          err.response?.data?.error || 
                          err.response?.data?.erro || 
                          err.response?.data?.detalhes ||
                          'Erro ao salvar agendamento';
      setError(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  // Excluir
  const handleExcluir = async () => {
    if (!agendamentoSelecionado) {
      setError('Nenhum agendamento selecionado para exclusão');
      return;
    }
    
    if (!agendamentoSelecionado._id) {
      setError('ID do agendamento inválido');
      return;
    }

    // Verifica se o agendamento é anterior à data atual
    let dataAgendamento;
    try {
      dataAgendamento = new Date(agendamentoSelecionado.dataHoraInicio);
      if (isNaN(dataAgendamento.getTime())) {
        dataAgendamento = null;
      }
    } catch (dateError) {
      dataAgendamento = null;
    }
    
    if (dataAgendamento) {
      const dataAtual = new Date();
      dataAtual.setHours(0, 0, 0, 0); // Remove horas para comparar apenas a data
      dataAgendamento.setHours(0, 0, 0, 0); // Remove horas para comparar apenas a data
      
      if (dataAgendamento < dataAtual) {
        setError('Agendamentos anteriores à data atual não podem ser excluídos');
        return;
      }
    }
    
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

      await api.delete(`/agendamentos/${agendamentoSelecionado._id}`, { headers });
      
      // Busca informações para o log
      const cliente = clientes.find(c => c.id === agendamentoSelecionado.clienteId);
      const colaborador = colaboradores.find(c => c.id === agendamentoSelecionado.colaboradorId);
      const servico = servicos.find(s => s.id === agendamentoSelecionado.servicoId);
      
      // Usa a data original do agendamento para o log
      const dataAgendamentoLog = new Date(agendamentoSelecionado.dataHoraInicio);
      const descricao = `Excluiu agendamento do cliente ${cliente?.nome_completo || 'N/A'}, colaborador ${colaborador?.nome_completo || 'N/A'}, serviço ${servico?.nome || 'N/A'} em ${format(dataAgendamentoLog, 'dd/MM/yyyy HH:mm')}`;
      
      await criarLogAuth(
        "EXCLUSAO",
        descricao,
        "DELETE",
        `/agendamentos/${agendamentoSelecionado._id}`
      );
      
      setSuccess('Agendamento excluído com sucesso!');
      handleCloseDelete();
      carregarAgendamentos();
    } catch (err) {
      const mensagemErro = err.response?.data?.message || 
                          err.response?.data?.error || 
                          err.response?.data?.erro || 
                          'Erro ao excluir agendamento';
      setError(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  // Carregar agendamentos
  const carregarAgendamentos = useCallback(async () => {
      setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

      const res = await api.get('/agendamentos', { headers });
      
      setAgendamentos(res.data || []);
    } catch (err) {
      const mensagemErro = err.response?.data?.message || 
                          err.response?.data?.error || 
                          err.response?.data?.erro || 
                          'Erro ao carregar agendamentos';
      setError(mensagemErro);
    } finally {
      setLoading(false);
    }
  }, []);

  const buscarDisponibilidadeColaborador = useCallback(async (colaboradorId) => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

        const res = await api.get(`/disponibilidade/${colaboradorId}`, { headers });
        if (res.data && Array.isArray(res.data)) {
        // Formata os dados da disponibilidade
        // Converte dias do backend (0-6) para formato do sistema (1-7)
        const disponibilidadeFormatada = res.data.map(disp => ({
          dia: converterJSparaSistema(disp.dia), // Backend usa 0-6, sistema usa 1-7
          inicio: disp.inicio.substring(0, 5), // Remove os segundos
          fim: disp.fim.substring(0, 5) // Remove os segundos
        }));
        setDisponibilidadeColaborador(disponibilidadeFormatada);
    } else {
        setDisponibilidadeColaborador([]);
      }
    } catch (err) {
      setError('Erro ao buscar disponibilidade do colaborador');
      setDisponibilidadeColaborador([]);
    }
  }, []);

  const handleColaboradorChange = async (e) => {
    if (viewMode) return; // Não permite alterações no modo de visualização
    
    // Em modo de edição, não permite alterar o colaborador
    const isEditMode = agendamentoSelecionado != null && !viewMode;
    if (isEditMode) return;
    
    const colaboradorId = e.target.value;
    setFormData(prev => ({ ...prev, colaboradorId }));
    setHorariosDisponiveis([]);
    
    // Limpa os estados relacionados à disponibilidade anterior
    setDisponibilidadeColaborador([]);
    setDiasSelecionados([]);
    
    if (colaboradorId) {
      // Busca a escala de trabalho/disponibilidade do colaborador
      await buscarDisponibilidadeColaborador(colaboradorId);
      
      // Se já houver uma data selecionada, busca os horários para o novo colaborador
      if (dataSelecionada) {
        buscarHorariosDisponiveisAPI(dataSelecionada, colaboradorId, formData.servicoId);
      }
    }
  };

  // ✅ SUGESTÃO DE REATORAÇÃO: A lógica de cálculo de horários foi movida para o backend.
  // Esta função agora apenas chama a API.
  const buscarHorariosDisponiveisAPI = useCallback(async (data, colaboradorId, servicoId) => {
    if (!data || !colaboradorId || !servicoId) {
      setHorariosDisponiveis([]);
      return;
    }

    try {
      setLoading(true); // Mostra um feedback para o usuário
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

      const dataFormatada = format(data, 'yyyy-MM-dd');
      const res = await api.get(`/colaboradores/${colaboradorId}/horarios-disponiveis`, {
        params: { data: dataFormatada, servicoId },
        headers
      });

      // A resposta da API já contém os horários livres
      setHorariosDisponiveis(res.data.map(horario => ({ horario, disponivel: true })));
    } catch (err) {
      setError('Erro ao buscar horários disponíveis.');
      setHorariosDisponiveis([]);
    } finally {
      setLoading(false);
    }
  }, [setHorariosDisponiveis, setLoading, setError]); // Dependências atualizadas


  const handleDiaSelecionado = (dia) => {
    if (viewMode) return; // Não permite alterações no modo de visualização
    
    // Em modo de edição, não permite alterar os dias
    const isEditMode = agendamentoSelecionado != null && !viewMode;
    if (isEditMode) return;
    
    setDiasSelecionados(prev => {
      const novosDias = prev.includes(dia) 
        ? prev.filter(d => d !== dia)
        : [...prev, dia];
      
      // Se tem data selecionada e o dia da data não está mais nos dias selecionados,
      // limpa a data e os horários
      if (dataSelecionada && !novosDias.includes(converterJSparaSistema(dataSelecionada.getDay()))) {
        setDataSelecionada(null);
        setHorariosDisponiveis([]);
        setFormData(prev => ({ ...prev, dataHoraInicio: '' }));
      }
      
      return novosDias;
    });
  };

  const handleDataChange = (data) => { // A função fica muito mais simples
    if (viewMode) return; // Não permite alterações no modo de visualização
    
    // Em modo de edição, não permite alterar a data
    const isEditMode = agendamentoSelecionado != null && !viewMode;
    if (isEditMode) return;
    
    setDataSelecionada(data);
    buscarHorariosDisponiveisAPI(data, formData.colaboradorId, formData.servicoId);

    // Limpa o horário selecionado ao mudar a data
    setFormData(prev => ({
      ...prev,
      dataHoraInicio: ''
    }));
  };

  const handleRequestSort = (property) => {
    const isAsc = order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleFiltroChange = (e) => {
    const { name, value } = e.target;
    setFiltros(prev => ({ ...prev, [name]: value }));
    setPage(0);
  };

  // Função para aplicar filtros
  const agendamentosFiltrados = agendamentos.filter(agendamento => {
    const cliente = clientes.find(c => c.id === agendamento.clienteId);
    const colaborador = colaboradores.find(c => c.id === agendamento.colaboradorId);
    const local = locais.find(l => l.id === agendamento.localId);
    const nomeCliente = cliente?.nome_completo?.toLowerCase() || '';
    const nomeColaborador = colaborador?.nome_completo?.toLowerCase() || '';
    const nomeLocal = local?.nome?.toLowerCase() || '';
    const filtroCliente = filtros.cliente.toLowerCase();
    const filtroColaborador = filtros.colaborador.toLowerCase();
    const filtroLocal = filtros.local.toLowerCase();

    return (
      (filtroCliente === '' || nomeCliente.includes(filtroCliente)) &&
      (filtroColaborador === '' || nomeColaborador.includes(filtroColaborador)) &&
      (filtroLocal === '' || nomeLocal.includes(filtroLocal))
    );
  });

  // Ordenação
  const agendamentosOrdenados = agendamentosFiltrados.sort((a, b) => {
    const isAsc = order === "asc";
    if (orderBy === "cliente") {
      const nomeA = clientes.find(c => c.id === a.clienteId)?.nome_completo || '';
      const nomeB = clientes.find(c => c.id === b.clienteId)?.nome_completo || '';
      return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
    }
    if (orderBy === "colaborador") {
      const nomeA = colaboradores.find(c => c.id === a.colaboradorId)?.nome_completo || '';
      const nomeB = colaboradores.find(c => c.id === b.colaboradorId)?.nome_completo || '';
      return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
    }
    if (orderBy === "local") {
      const nomeA = locais.find(l => l.id === a.localId)?.nome || '';
      const nomeB = locais.find(l => l.id === b.localId)?.nome || '';
      return isAsc ? nomeA.localeCompare(nomeB) : nomeB.localeCompare(nomeA);
    }
    if (orderBy === "dataHoraInicio") {
      return isAsc ? 
        new Date(a.dataHoraInicio) - new Date(b.dataHoraInicio) :
        new Date(b.dataHoraInicio) - new Date(a.dataHoraInicio);
    }
    return 0;
  });

  // Paginação
  const agendamentosPaginados = agendamentosOrdenados.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  // Função para buscar colaboradores do serviço
  const buscarColaboradoresServico = async (servicoId) => {
    if (!servicoId) {
      setColaboradoresServico([]);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

        const res = await api.get(`/servico-colaboradores/${servicoId}`, { headers });

      if (res.data && Array.isArray(res.data)) {
        // Mapeia os colaboradores retornados
        const colaboradoresDoServico = res.data.map(colaborador => ({
          id: colaborador.id,
          nome_completo: colaborador.nome_completo || colaborador.nome
        }));
        setColaboradoresServico(colaboradoresDoServico);
      } else if (res.data && res.data.colaboradores && Array.isArray(res.data.colaboradores)) {
        // Caso a resposta venha em um objeto com propriedade colaboradores
        const colaboradoresDoServico = res.data.colaboradores.map(colaborador => ({
          id: colaborador.id,
          nome_completo: colaborador.nome_completo || colaborador.nome
        }));
        setColaboradoresServico(colaboradoresDoServico);
      } else {
        setColaboradoresServico([]);
      }
    } catch (err) {
      setError(`Erro ao buscar colaboradores do serviço: ${err.message}`);
      setColaboradoresServico([]);
    }
  };

  // Atualiza a lista de colaboradores quando o serviço muda
  useEffect(() => {
    if (formData.servicoId) {
      setColaboradoresServico([]);
      setHorariosDisponiveis([]);
      buscarColaboradoresServico(formData.servicoId);
    } else { // Se o serviço for limpo
      setColaboradoresServico([]);
      setDisponibilidadeColaborador([]);
      setDiasSelecionados([]);
      setDataSelecionada(null);
      setHorariosDisponiveis([]);
    }
  }, [formData.servicoId]);

  return (
    <AcessoRestrito modulo="agendamentoindividual">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Snackbar 
          open={!!error} 
          autoHideDuration={6000} 
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>

        <Snackbar 
          open={!!success} 
          autoHideDuration={6000} 
          onClose={() => setSuccess(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
            {success}
          </Alert>
        </Snackbar>
        
        {/* Box interno com margens de 1,5% */}
        <Box sx={{
          margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            pb: 2,
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Typography 
              variant="h5" 
              mb={1} 
              sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              Agendamentos Individuais
            </Typography>
            <Button 
              variant="contained" 
              onClick={() => handleOpenForm()}
              sx={{
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.5 }
              }}
            >
              <AddIcon sx={{ mr: 1 }} /> Novo Agendamento
            </Button>
          </Box>

        <TableContainer 
          component={Paper} 
          sx={{ 
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            overflow: 'auto',
            height: {
              xs: 'calc(90vh - 140px)',  // Mobile: mais espaço para header
              sm: 'calc(90vh - 120px)',  // Tablet: espaço padrão
              md: 'calc(90vh - 120px)',  // Desktop: espaço padrão
              lg: 'calc(90vh - 120px)'   // Large: espaço padrão
            },
            maxHeight: {
              xs: 'calc(90vh - 140px)',
              sm: 'calc(90vh - 120px)',
              md: 'calc(90vh - 120px)',
              lg: 'calc(90vh - 120px)'
            }
          }}
        >
          <Table sx={{ 
            minWidth: { xs: 800, sm: 650 }, 
            tableLayout: 'fixed',
            width: '100%'
          }}>
            <TableHead sx={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              backgroundColor: (theme) => theme.palette.background.paper,
              '& .MuiTableCell-root': {
                backgroundColor: (theme) => theme.palette.background.paper,
                borderBottom: 2,
                borderBottomColor: 'divider'
              }
            }}>
              <TableRow>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  minWidth: { xs: '150px', sm: '120px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "cliente"}
                    direction={orderBy === "cliente" ? order : "asc"}
                    onClick={() => handleRequestSort("cliente")}
                  >
                    Cliente
                  </TableSortLabel>
                  <TextField
                    name="cliente"
                    size="small"
                    fullWidth
                    value={filtros.cliente}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por cliente"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '25%', sm: '20%' },
                  minWidth: { xs: '150px', sm: '120px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "colaborador"}
                    direction={orderBy === "colaborador" ? order : "asc"}
                    onClick={() => handleRequestSort("colaborador")}
                  >
                    Colaborador
                  </TableSortLabel>
                  <TextField
                    name="colaborador"
                    size="small"
                    fullWidth
                    value={filtros.colaborador}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por colaborador"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '15%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "local"}
                    direction={orderBy === "local" ? order : "asc"}
                    onClick={() => handleRequestSort("local")}
                  >
                    Local
                  </TableSortLabel>
                  <TextField
                    name="local"
                    size="small"
                    fullWidth
                    value={filtros.local}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por local"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '15%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  <TableSortLabel
                    active={orderBy === "dataHoraInicio"}
                    direction={orderBy === "dataHoraInicio" ? order : "asc"}
                    onClick={() => handleRequestSort("dataHoraInicio")}
                  >
                    Data/Hora
                  </TableSortLabel>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '15%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : agendamentosPaginados.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Nenhum agendamento encontrado.
                  </TableCell>
                </TableRow>
              ) : (
                agendamentosPaginados.map((agendamento) => {
                  return (
                    <TableRow key={agendamento._id}>
                      <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {clientes.find(c => c.id === agendamento.clienteId)?.nome_completo || agendamento.clienteId}
                      </TableCell>
                      <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {colaboradores.find(c => c.id === agendamento.colaboradorId)?.nome_completo || agendamento.colaboradorId}
                      </TableCell>
                      <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {locais.find(l => l.id === agendamento.localId)?.nome || agendamento.localId}
                      </TableCell>
                      <TableCell sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {format(parseISO(agendamento.dataHoraInicio), 'dd/MM/yyyy HH:mm', { locale: ptBR })} - {format(parseISO(agendamento.dataHoraFim), 'HH:mm', { locale: ptBR })}
                      </TableCell>
                      <TableCell>
                        <Box sx={{ 
                          display: 'flex', 
                          gap: 1,
                          justifyContent: 'flex-end'
                        }}>
                          <Tooltip title="Visualizar">
                            <IconButton size="small" onClick={() => handleOpenForm(agendamento, true)}>
                              <VisibilityIcon fontSize="small" className="material-icon-visibility" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Editar">
                            <IconButton size="small" onClick={() => handleOpenForm(agendamento)}>
                              <EditIcon fontSize="small" className="material-icon-edit" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Excluir">
                            <IconButton size="small" onClick={() => handleOpenDelete(agendamento)}>
                              <DeleteIcon fontSize="small" className="material-icon-delete" />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={agendamentosFiltrados.length}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage="Itens por página"
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          sx={{
            position: 'sticky',
            bottom: 0,
            backgroundColor: 'background.paper',
            borderTop: 1,
            borderColor: 'divider',
            width: '100%'
          }}
        />

        {/* Formulário */}
        <Dialog 
          open={openForm} 
          onClose={handleCloseForm} 
          maxWidth="md" 
          fullWidth
          PaperProps={{
            sx: {
              width: { xs: '95vw', sm: '90vw', md: '900px' },
              height: { xs: '95vh', sm: '90vh', md: '550px' },
              maxWidth: '900px',
              maxHeight: '550px',
              position: 'relative'
            }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            {viewMode ? "Visualizar Agendamento" : agendamentoSelecionado ? "Editar Agendamento" : "Novo Agendamento"}
          </DialogTitle>
          <DialogContent sx={{ 
            height: 'calc(100% - 120px)',
            overflow: 'auto',
            padding: 2,
            '&.MuiDialogContent-root': {
              paddingTop: 2
            },
            position: 'relative',
            top: 0,
            marginBottom: '60px',
            '& .MuiInputLabel-root': {
              fontSize: '0.875rem'
            },
            '& .MuiInputBase-input': {
              fontSize: '0.875rem'
            },
            '& .MuiFormControlLabel-label': {
              fontSize: '0.875rem'
            }
          }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* 1. Seleção de Cliente */}
              <FormControl fullWidth error={formErrors.clienteId}>
                <Autocomplete
                  options={clientesOrdenados}
                  getOptionLabel={(option) => option.nome_completo || option.nome || ''}
                  value={clientesOrdenados.find(cliente => cliente.id === formData.clienteId) || null}
                  onChange={(event, newValue) => {
                    const isEditMode = agendamentoSelecionado != null && !viewMode;
                    if (!viewMode && !isEditMode) {
                      if (newValue) {
                        setFormData(prev => ({ ...prev, clienteId: newValue.id }));
                        setClienteSelecionado(newValue);
                      } else {
                        setFormData(prev => ({ ...prev, clienteId: '' }));
                        setClienteSelecionado(null);
                      }
                    }
                  }}
                  disabled={viewMode || (agendamentoSelecionado != null && !viewMode)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Cliente"
                      error={formErrors.clienteId}
                      helperText={formErrors.clienteId ? "Cliente é obrigatório" : ""}
                      placeholder="Digite para buscar..."
                    />
                  )}
                  renderOption={(props, option) => (
                    <Box component="li" {...props}>
                      <Box>
                        <Typography variant="body1">
                          {option.nome_completo || option.nome}
                        </Typography>
                        {option.cpf_cnpj && (
                          <Typography variant="caption" color="text.secondary">
                            {formatarCPFCNPJLGPD(option.cpf_cnpj, option.tipo_pessoa, true)}
                          </Typography>
                        )}
                      </Box>
                    </Box>
                  )}
                  filterOptions={(options, { inputValue }) => {
                    const filterValue = inputValue.toLowerCase();
                    return options.filter(option => {
                      const nome = (option.nome_completo || option.nome || '').toLowerCase();
                      const cpf = (option.cpf_cnpj || '').toLowerCase();
                      return nome.includes(filterValue) || cpf.includes(filterValue);
                    });
                  }}
                  noOptionsText="Nenhum cliente encontrado"
                  loading={loading}
                  loadingText="Carregando clientes..."
                  sx={{
                    '& .MuiAutocomplete-input': {
                      fontSize: '0.875rem'
                    }
                  }}
                />
              </FormControl>

              {/* CPF/CNPJ, Data de Nascimento, RG e Gênero */}
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField
                  sx={{ width: '25%' }}
                  label="CPF/CNPJ"
                  value={clienteSelecionado?.cpf_cnpj ? formatarCPFCNPJLGPD(clienteSelecionado.cpf_cnpj, clienteSelecionado.tipo_pessoa, true) : ''}
                  InputProps={{ 
                    readOnly: true,
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      '& .MuiInputBase-input': {
                        color: 'rgba(0, 0, 0, 0.6)'
                      }
                    }
                  }}
                />
                <TextField
                  sx={{ width: '25%' }}
                  label="Data de Nascimento"
                  value={clienteSelecionado?.data_nascimento ? format(new Date(clienteSelecionado.data_nascimento), 'dd/MM/yyyy') : ''}
                  InputProps={{ 
                    readOnly: true,
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      '& .MuiInputBase-input': {
                        color: 'rgba(0, 0, 0, 0.6)'
                      }
                    }
                  }}
                />
                <TextField
                  sx={{ width: '25%' }}
                  label="RG"
                  value={clienteSelecionado?.rg || ''}
                  InputProps={{ 
                    readOnly: true,
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      '& .MuiInputBase-input': {
                        color: 'rgba(0, 0, 0, 0.6)'
                      }
                    }
                  }}
                />
                <TextField
                  sx={{ width: '25%' }}
                  label="Gênero"
                  value={clienteSelecionado?.genero || ''}
                  InputProps={{ 
                    readOnly: true,
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      '& .MuiInputBase-input': {
                        color: 'rgba(0, 0, 0, 0.6)'
                      }
                    }
                  }}
                />
              </Box>

              {/* Observação do Cliente (somente leitura) */}
              {clienteSelecionado?.observacao && (
                <TextField
                  fullWidth
                  label="Observação do Cliente"
                  value={clienteSelecionado.observacao}
                  multiline
                  rows={2}
                  InputProps={{ 
                    readOnly: true,
                    sx: {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      '& .MuiInputBase-input': {
                        color: 'rgba(0, 0, 0, 0.6)'
                      }
                    }
                  }}
                />
              )}

              {/* Observações do Agendamento - Apenas em novo agendamento (não em edição ou visualização) */}
              {!agendamentoSelecionado && (
                <TextField
                  fullWidth
                  label="Observações do Agendamento"
                  value={formData.observacoes || ''}
                  onChange={handleInputChange}
                  name="observacoes"
                  multiline
                  rows={3}
                  placeholder="Adicione observações sobre este agendamento..."
                />
              )}

              {/* 7. Serviço e Duração - Oculto em modo de visualização e edição */}
              {!viewMode && !(agendamentoSelecionado != null && !viewMode) && (
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <Autocomplete
                    sx={{ width: '80%' }}
                    options={[...servicos].sort((a, b) => {
                      const nomeA = (a.nome || '').toLowerCase();
                      const nomeB = (b.nome || '').toLowerCase();
                      return nomeA.localeCompare(nomeB);
                    })}
                    value={servicos.find(
                      servico => String(servico.id) === String(formData.servicoId)
                    ) || null}
                    onChange={(_event, servico) => {
                      handleInputChange({
                        target: { name: 'servicoId', value: servico?.id ?? '' }
                      });
                    }}
                    getOptionLabel={(servico) => (
                      `${servico.nome || ''} - ${servico.categoria || ''} (${servico.duracao_minutos || 0} min)`
                    )}
                    isOptionEqualToValue={(option, value) => (
                      String(option.id) === String(value.id)
                    )}
                    disabled={viewMode || (agendamentoSelecionado != null && !viewMode)}
                    noOptionsText="Nenhum serviço encontrado"
                    slotProps={{
                      listbox: {
                        sx: {
                          maxHeight: 280,
                          overflowY: 'auto'
                        }
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Serviço"
                        placeholder="Digite para buscar..."
                        error={formErrors.servicoId}
                        helperText={formErrors.servicoId ? 'Serviço é obrigatório' : ''}
                      />
                    )}
                  />

                      <TextField
                    sx={{ width: '20%' }}
                        label="Duração"
                    value={formData.servicoId ? `${servicos.find(s => s.id === formData.servicoId)?.duracao_minutos || 0} minutos` : ''}
                        InputProps={{ 
                          readOnly: true,
                      sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        '& .MuiInputBase-input': {
                          color: 'rgba(0, 0, 0, 0.6)'
                        }
                      }
                        }}
                      />
                    </Box>
              )}

              {/* 8. Seleção de Local - Oculto em modo de visualização e edição */}
              {!viewMode && !(agendamentoSelecionado != null && !viewMode) && (
                    <Box sx={{ display: 'flex', gap: 2 }}>
                  <FormControl sx={{ width: '20%' }}>
                    <InputLabel>Local</InputLabel>
                          <Select
                      name="local_execucao"
                      value={formData.local_execucao.tipo || ''}
                      label="Local"
                      disabled={true}
                    >
                      {formData.servicoId && servicos.find(s => s.id === formData.servicoId)?.local_execucao ? [
                        <MenuItem 
                          key="servico-local" 
                          value={servicos.find(s => s.id === formData.servicoId).local_execucao.tipo}
                        >
                          {servicos.find(s => s.id === formData.servicoId).local_execucao.tipo === 'presencial' ? 'Presencial' : 
                           servicos.find(s => s.id === formData.servicoId).local_execucao.tipo === 'online' ? 'Online' : 'Híbrido'}
                        </MenuItem>
                      ] : [
                        <MenuItem key="online" value="online">Online</MenuItem>,
                        <MenuItem key="presencial" value="presencial">Presencial</MenuItem>,
                        <MenuItem key="hibrido" value="hibrido">Híbrido</MenuItem>
                      ]}
                          </Select>
                        </FormControl>

                          <TextField 
                    sx={{ width: '80%' }}
                    label="Endereço do Local"
                    value={(formData.servicoId && servicos.find(s => s.id === formData.servicoId)?.local_execucao?.local) || formData.local_execucao.local || ''}
                    disabled={true}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        '& .MuiInputBase-input': {
                          color: 'rgba(0, 0, 0, 0.6)'
                        }
                      }
                    }}
                  />
                      </Box>
              )}
              {!viewMode && !(agendamentoSelecionado != null && !viewMode) && !formData.servicoId && (
                <FormHelperText>Selecione um serviço primeiro</FormHelperText>
                  )}

              {/* 9. Seleção de Colaborador - Oculto em modo de visualização e edição */}
              {!viewMode && !(agendamentoSelecionado != null && !viewMode) && (
                <FormControl fullWidth error={formErrors.colaboradorId}>
                      <InputLabel>Colaborador</InputLabel>
                      <Select
                    name="colaboradorId"
                    value={formData.colaboradorId}
                        onChange={handleColaboradorChange}
                        label="Colaborador"
                    disabled={viewMode || (agendamentoSelecionado != null && !viewMode) || !formData.servicoId}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 300
                            }
                          }
                        }}
                        renderValue={(value) => {
                          if (!value) return '';
                          
                          // Função auxiliar para comparar IDs robustamente
                          const idsMatch = (id1, id2) => {
                            if (Number(id1) === Number(id2)) return true;
                            if (String(id1) === String(id2)) return true;
                            return parseInt(id1, 10) === parseInt(id2, 10);
                          };
                          
                          // Tenta encontrar na lista de colaboradores do serviço
                          let colaborador = colaboradoresServico.find(c => idsMatch(c.id, value));
                          
                          // Se não encontrar, busca na lista completa de colaboradores
                          if (!colaborador) {
                            colaborador = colaboradores.find(c => idsMatch(c.id, value));
                          }
                          
                          return colaborador ? colaborador.nome_completo || colaborador.nome : '';
                        }}
                      >
                  {(() => {
                    // Cria uma lista combinada de colaboradores do serviço + colaborador selecionado (se não estiver na lista)
                    const colaboradoresLista = [...colaboradoresServico];
                    
                    // Se há um colaborador selecionado que não está na lista, adiciona da lista completa
                    if (formData.colaboradorId) {
                      // Função auxiliar para comparar IDs robustamente
                      const idsMatch = (id1, id2) => {
                        if (Number(id1) === Number(id2)) return true;
                        if (String(id1) === String(id2)) return true;
                        return parseInt(id1, 10) === parseInt(id2, 10);
                      };
                      
                      const colaboradorSelecionado = colaboradores.find(c => idsMatch(c.id, formData.colaboradorId));
                      
                      if (colaboradorSelecionado && !colaboradoresLista.find(c => idsMatch(c.id, colaboradorSelecionado.id))) {
                        colaboradoresLista.push(colaboradorSelecionado);
                      }
                    }
                    
                    if (colaboradoresLista.length > 0) {
                      // Ordena colaboradores alfabeticamente por nome
                      const colaboradoresOrdenados = [...colaboradoresLista].sort((a, b) => {
                        const nomeA = (a.nome_completo || a.nome || '').toLowerCase();
                        const nomeB = (b.nome_completo || b.nome || '').toLowerCase();
                        return nomeA.localeCompare(nomeB);
                      });
                      
                      return colaboradoresOrdenados.map((colaborador, index) => (
                        <MenuItem 
                          key={`colaborador-${colaborador.id}-${index}`} 
                          value={colaborador.id}
                          sx={{ 
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            py: 1
                          }}
                        >
                          {colaborador.nome_completo || colaborador.nome}
                        </MenuItem>
                      ));
                    } else {
                      return (
                        <MenuItem disabled>
                          {formData.servicoId ? 'Nenhum colaborador disponível' : 'Selecione um serviço primeiro'}
                        </MenuItem>
                      );
                    }
                  })()}
                    </Select>
                      {formErrors.colaboradorId && (
                        <FormHelperText error>Colaborador é obrigatório</FormHelperText>
                      )}
                      {!formData.servicoId && (
                        <FormHelperText>Selecione um serviço primeiro</FormHelperText>
                      )}
                    </FormControl>
              )}

              {/* 10 e 11. Disponibilidade e Calendário - Oculto em modo de visualização e edição */}
              {!viewMode && !(agendamentoSelecionado != null && !viewMode) && (
                <Box sx={{ display: 'flex', gap: 2 }}>
                  {/* Disponibilidade do Colaborador */}
                  <Box sx={{ width: '50%' }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Disponibilidade do Colaborador
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  {formData.colaboradorId ? (
                        disponibilidadeColaborador.length > 0 ? (
                          // Ordena por dia da semana (1=Domingo, 2=Segunda, ..., 7=Sábado)
                          [...disponibilidadeColaborador]
                            .sort((a, b) => a.dia - b.dia)
                            .map((disp, index) => (
                            <Chip
                              key={`disp-${disp.dia}-${index}`}
                              label={`${diasSemana[disp.dia]}: ${disp.inicio} - ${disp.fim}`}
                              onClick={() => handleDiaSelecionado(disp.dia)}
                          color={diasSelecionados.includes(disp.dia) ? 'primary' : 'default'}
                              sx={{ width: '100%', justifyContent: 'flex-start' }}
                            />
                          ))
                        ) : (
                          <Typography color="text.secondary">
                            Nenhuma disponibilidade cadastrada para este colaborador
                          </Typography>
                        )
                      ) : (
                        <Typography color="text.secondary">
                          Selecione um colaborador para ver sua disponibilidade
                        </Typography>
                      )}
                    </Box>
                {formErrors.diasSelecionados && (
                  <FormHelperText error>Selecione pelo menos um dia</FormHelperText>
                )}
                  </Box>

                  {/* Seleção de Data */}
                  <Box sx={{ width: '50%', display: 'flex', flexDirection: 'column' }}>
                    <Typography variant="subtitle1" gutterBottom>
                      Data
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                      <DesktopDatePicker
                        label="Selecione a data"
                    value={dataSelecionada}
                    onChange={handleDataChange}
                        shouldDisableDate={(date) => {
                          const hoje = new Date();
                          hoje.setHours(0, 0, 0, 0); // Remove horas para comparar apenas a data
                          
                          // Desabilita datas passadas
                          if (date < hoje) {
                            return true;
                          }
                          
                          // Se não há dias selecionados, permite selecionar qualquer dia da disponibilidade
                          if (diasSelecionados.length === 0) {
                            // Permite apenas dias que estão na disponibilidade do colaborador
                            const diaSemanaJS = date.getDay(); // JS retorna 0-6
                            const diaSemana = converterJSparaSistema(diaSemanaJS); // Converte para formato do sistema (1-7)
                            const diaTemDisponibilidade = disponibilidadeColaborador.some(disp => disp.dia === diaSemana);
                            return !diaTemDisponibilidade;
                          }
                          
                          // Desabilita dias da semana que NÃO foram selecionados nos chips de disponibilidade
                          // Só permite selecionar datas dos dias que o usuário clicou nos chips
                          const diaSemanaJS = date.getDay(); // JS retorna 0-6
                          const diaSemana = converterJSparaSistema(diaSemanaJS); // Converte para formato do sistema (1-7)
                          return !diasSelecionados.includes(diaSemana);
                        }}
                    disabled={!formData.colaboradorId || disponibilidadeColaborador.length === 0}
                        renderInput={(params) => (
                          <TextField 
                            {...params} 
                            fullWidth 
                        error={formErrors.dataSelecionada}
                            inputProps={{
                              ...params.inputProps,
                              readOnly: true
                            }}
                            helperText={
                          formErrors.dataSelecionada 
                                ? "Data é obrigatória" 
                            : !formData.colaboradorId 
                              ? "Selecione um colaborador" 
                              : diasSelecionados.length === 0 
                                  ? "Selecione os dias disponíveis" 
                                  : ""
                            }
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              )}

              {/* 12. Horários Disponíveis - Oculto em modo de visualização e edição */}
              {!viewMode && !(agendamentoSelecionado != null && !viewMode) && (
                <Box>
                  <Typography variant="subtitle1" gutterBottom>
                    Horários Disponíveis
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {horariosDisponiveis.map((horario, index) => (
                      <Chip
                        key={`horario-${horario.horario}-${index}`}
                        label={horario.horario}
                        onClick={() => {
                          if (!horario.disponivel) return; // Não permite clique em horários ocupados
                          
                          const [hora, minuto] = horario.horario.split(':');
                          const dataHoraInicio = new Date(dataSelecionada);
                          dataHoraInicio.setHours(parseInt(hora));
                          dataHoraInicio.setMinutes(parseInt(minuto));
                          dataHoraInicio.setSeconds(0);
                          dataHoraInicio.setMilliseconds(0);
                          
                          // Salva o horário como string local com timezone offset
                          const ano = dataHoraInicio.getFullYear();
                          const mes = String(dataHoraInicio.getMonth() + 1).padStart(2, '0');
                          const dia = String(dataHoraInicio.getDate()).padStart(2, '0');
                          const horaStr = String(dataHoraInicio.getHours()).padStart(2, '0');
                          const minutoStr = String(dataHoraInicio.getMinutes()).padStart(2, '0');
                          const segundoStr = String(dataHoraInicio.getSeconds()).padStart(2, '0');
                          
                          // Calcula o timezone offset local
                          const tzOffset = -new Date().getTimezoneOffset(); // ex: -180 minutos
                          const offsetSign = tzOffset >= 0 ? '+' : '-';
                          const offsetHours = String(Math.floor(Math.abs(tzOffset) / 60)).padStart(2, '0');
                          const offsetMinutes = String(Math.abs(tzOffset) % 60).padStart(2, '0');
                          const timezoneOffset = `${offsetSign}${offsetHours}:${offsetMinutes}`;
                          
                          const dataHoraString = `${ano}-${mes}-${dia}T${horaStr}:${minutoStr}:${segundoStr}${timezoneOffset}`;
                          
                          setFormData(prev => ({
                            ...prev,
                            dataHoraInicio: dataHoraString
                          }));
                        }}
                        color={
                          !horario.disponivel 
                            ? 'error' 
                            : formData.dataHoraInicio && format(new Date(formData.dataHoraInicio), 'HH:mm') === horario.horario 
                              ? 'primary' 
                              : 'default'
                        }
                        disabled={!horario.disponivel}
                        sx={{
                          opacity: horario.disponivel ? 1 : 0.7,
                          cursor: horario.disponivel ? 'pointer' : 'not-allowed'
                        }}
                      />
                    ))}
                  </Box>
                  {formErrors.dataHoraInicio && (
                    <FormHelperText error>Selecione um horário</FormHelperText>
                  )}
                </Box>
              )}

              {/* Informações do Agendamento (exibição em visualização e edição) */}
              {(viewMode || (agendamentoSelecionado != null && !viewMode)) && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2, p: 2, bgcolor: 'rgba(0, 0, 0, 0.02)', borderRadius: 1 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
                    Informações do Agendamento
                  </Typography>
                  
                  {/* Serviço */}
                  <TextField
                    fullWidth
                    label="Serviço"
                    value={(() => {
                      if (!formData.servicoId) return 'Não informado';
                      
                      // Busca o serviço (pode ser string ou number)
                      const servico = servicos.find(s => 
                        String(s.id) === String(formData.servicoId) || s.id === formData.servicoId
                      );
                      
                      if (servico) {
                        const categoria = servico.categoria || '';
                        const duracao = servico.duracao_minutos || 0;
                        return categoria 
                          ? `${servico.nome} - ${categoria} (${duracao} min)`
                          : `${servico.nome} (${duracao} min)`;
                      }
                      return 'Não encontrado';
                    })()}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        '& .MuiInputBase-input': {
                          color: 'rgba(0, 0, 0, 0.87)',
                          fontWeight: 500
                        }
                      }
                    }}
                  />

                  {/* Data e Hora */}
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                      sx={{ flex: 1 }}
                      label="Data do Agendamento"
                      value={formData.dataHoraInicio ? format(new Date(formData.dataHoraInicio), 'dd/MM/yyyy', { locale: ptBR }) : ''}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          '& .MuiInputBase-input': {
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 500
                          }
                        }
                      }}
                    />
                    <TextField
                      sx={{ flex: 1 }}
                      label="Hora de Início"
                      value={formData.dataHoraInicio ? format(new Date(formData.dataHoraInicio), 'HH:mm', { locale: ptBR }) : ''}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          '& .MuiInputBase-input': {
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 500
                          }
                        }
                      }}
                    />
                    <TextField
                      sx={{ flex: 1 }}
                      label="Hora de Término"
                      value={formData.dataHoraFim ? format(new Date(formData.dataHoraFim), 'HH:mm', { locale: ptBR }) : ''}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          '& .MuiInputBase-input': {
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 500
                          }
                        }
                      }}
                    />
                  </Box>

                  {/* Colaborador */}
                  <TextField
                    fullWidth
                    label="Colaborador"
                    value={(() => {
                      if (!formData.colaboradorId && formData.colaboradorId !== 0) {
                        return 'Não informado';
                      }
                      
                      // Normaliza IDs para comparação robusta (pode ser Number, String ou Decimal)
                      const colaboradorIdValue = formData.colaboradorId;
                      
                      // Função auxiliar para comparar IDs
                      const idsMatch = (id1, id2) => {
                        // Compara como números (para lidar com 20.0 === 20)
                        const num1 = Number(id1);
                        const num2 = Number(id2);
                        if (!isNaN(num1) && !isNaN(num2) && num1 === num2) return true;
                        // Compara como strings
                        if (String(id1) === String(id2)) return true;
                        // Compara parseando ambos como inteiros
                        const int1 = parseInt(id1, 10);
                        const int2 = parseInt(id2, 10);
                        if (!isNaN(int1) && !isNaN(int2) && int1 === int2) return true;
                        return false;
                      };
                      
                      // Tenta encontrar na lista de colaboradores do serviço
                      let colaborador = colaboradoresServico.find(c => idsMatch(c.id, colaboradorIdValue));
                      
                      // Se não encontrar, busca na lista completa de colaboradores
                      if (!colaborador) {
                        colaborador = colaboradores.find(c => idsMatch(c.id, colaboradorIdValue));
                      }
                      
                      
                      return colaborador ? colaborador.nome_completo || colaborador.nome : 'Não encontrado';
                    })()}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        '& .MuiInputBase-input': {
                          color: 'rgba(0, 0, 0, 0.87)',
                          fontWeight: 500
                        }
                      }
                    }}
                  />

                  {/* Local */}
                  <TextField
                    fullWidth
                    label="Local do Atendimento"
                    value={(() => {
                      if (!formData.localId) return 'Não informado';
                      
                      // Normaliza IDs para comparação
                      const localIdNum = Number(formData.localId);
                      const local = locais.find(l => 
                        Number(l.id) === localIdNum || String(l.id) === String(formData.localId)
                      );
                      
                      return local ? local.nome || local.endereco || 'Não informado' : 'Não encontrado';
                    })()}
                    InputProps={{
                      readOnly: true,
                      sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        '& .MuiInputBase-input': {
                          color: 'rgba(0, 0, 0, 0.87)',
                          fontWeight: 500
                        }
                      }
                    }}
                  />

                  {/* Tipo de Local de Execução */}
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <TextField
                      sx={{ flex: 1 }}
                      label="Tipo de Execução"
                      value={(() => {
                        const tipo = formData.local_execucao?.tipo || '';
                        if (tipo === 'presencial') return 'Presencial';
                        if (tipo === 'online') return 'Online';
                        if (tipo === 'hibrido') return 'Híbrido';
                        return 'Não informado';
                      })()}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          '& .MuiInputBase-input': {
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 500
                          }
                        }
                      }}
                    />
                    <TextField
                      sx={{ flex: 2 }}
                      label="Endereço/Local de Execução"
                      value={formData.local_execucao?.local || 'Não informado'}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          '& .MuiInputBase-input': {
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 500
                          }
                        }
                      }}
                    />
                  </Box>

                  {/* Status */}
                  {formData.status && (
                    <TextField
                      fullWidth
                      label="Status"
                      value={formData.status}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          '& .MuiInputBase-input': {
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 500
                          }
                        }
                      }}
                    />
                  )}

                  {/* Observações - apenas em modo de visualização */}
                  {viewMode && (
                    <TextField
                      fullWidth
                      label="Observações do Agendamento"
                      value={formData.observacoes || 'Não informado'}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          '& .MuiInputBase-input': {
                            color: 'rgba(0, 0, 0, 0.87)',
                            fontWeight: 500
                          }
                        }
                      }}
                      multiline
                      rows={3}
                    />
                  )}
                </Box>
              )}

              {/* Campo de Observações editável - apenas em modo de edição (não visualização) */}
              {!viewMode && agendamentoSelecionado != null && (
                <TextField
                  fullWidth
                  label="Observações do Agendamento"
                  value={formData.observacoes || ''}
                  onChange={handleInputChange}
                  name="observacoes"
                  multiline
                  rows={3}
                  placeholder="Adicione observações sobre este agendamento..."
                  sx={{ mt: 2 }}
                />
              )}
            </Box>
          </DialogContent>
          <DialogActions sx={{ 
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: 2,
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderTop: 1,
            borderColor: 'divider',
            zIndex: 1,
            height: '60px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .MuiButton-root': {
              fontSize: '0.875rem',
              textTransform: 'uppercase',
              fontWeight: 500
            },
            '& .MuiTypography-root': {
              fontSize: '0.875rem'
            }
          }}>
            <Typography variant="body2" color="text.secondary">
              {new Date().toLocaleString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
              <Button 
                onClick={handleCloseForm}
                variant="outlined" 
                color="primary"
              >
                FECHAR
              </Button>
              {!viewMode && (
                <Button 
                  onClick={handleSalvar} 
                  variant="contained" 
                  color="primary"
                  disabled={loading}
                  sx={{ ml: 1 }}
                >
                  {loading ? <CircularProgress size={24} /> : "SALVAR"}
                </Button>
              )}
            </Box>
          </DialogActions>
        </Dialog>

        {/* Confirmação de exclusão */}
        <Dialog 
          open={openDelete} 
          onClose={handleCloseDelete} 
          maxWidth="sm" 
          fullWidth
          PaperProps={{
            sx: {
              width: { xs: '95vw', sm: '90vw', md: '400px' },
              maxWidth: '400px',
              position: 'relative'
            }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2
          }}>
            Confirmar Exclusão
          </DialogTitle>
          <DialogContent sx={{ padding: 2 }}>
            <Typography>
              Tem certeza que deseja excluir este agendamento?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderTop: 1,
            borderColor: 'divider',
            padding: 2
          }}>
            <Button onClick={handleCloseDelete}>Cancelar</Button>
            <Button 
              variant="contained" 
              color="error" 
              onClick={handleExcluir} 
              disabled={loading}
            >
              Excluir
            </Button>
          </DialogActions>
        </Dialog>
        </Box>
      </Box>
    </AcessoRestrito>
  );
}
